<template>
  <span class="SectionTitle">{{ title }}</span>
</template>
<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>
<style lang="scss">
.SectionTitle {
  color: rgb(var(--v-theme-main-blue));
  font-size: var(--font-size-h3);
  font-weight: 700;
}

/* Small screens: set font-size to 20px */
@media (max-width: 600px) {
  .SectionTitle {
    font-size: 20px;
  }
}
</style>
